import { Injectable, Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'

@Pipe({name: 'safeUrl'})

export class SanitizeUrl {
  constructor(private sanitizer: DomSanitizer){}

  transform(url) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}



// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/core/pipes/sanitize-url.ts